<template>
  <div
    v-if="label"
    class="garan-label"
    :class="{ 'garan-label--inline': inline }"
  >
    <button
      type="button"
      class="garan-label__trigger"
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-label="expanded ? 'GARAN-Kennzeichnung ausblenden' : 'GARAN-Kennzeichnung anzeigen'"
      @click="expanded = !expanded"
    >
      <span
        v-show="!expanded"
        class="garan-label__preview"
        v-html="nestedMarkup"
      />
      <span
        v-show="expanded"
        class="garan-label__full"
        v-html="fullMarkup"
      />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fullGaranMarkup, nestedGaranMarkup, resolveGaranLabel } from 'theme/helpers/garan-label'

export default {
  name: 'MGaranLabel',
  props: {
    product: {
      type: Object,
      required: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    ...mapGetters({
      attributesByCode: 'attribute/attributeListByCode'
    }),
    label () {
      return resolveGaranLabel(this.product, this.attributesByCode)
    },
    uid () {
      return 'g' + this._uid
    },
    nestedMarkup () {
      return this.label ? nestedGaranMarkup(this.label, this.uid) : ''
    },
    fullMarkup () {
      return this.label ? fullGaranMarkup(this.label, this.uid) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.garan-label {
  margin-top: 16px;

  &__trigger {
    display: inline-flex;
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: none;
    box-shadow: none;
    line-height: 0;
    cursor: pointer;
  }

  &__preview ::v-deep svg,
  &__full ::v-deep svg {
    display: block;
    width: 100%;
    height: auto;
    background: #fff;
  }

  &__preview ::v-deep svg {
    max-width: 200px;
  }

  &__full ::v-deep svg {
    max-width: 320px;
  }

  &--inline {
    display: block;
    width: 100%;
    max-width: 280px;
    margin: 0 0 10px;

    .garan-label__trigger {
      width: 100%;
    }

    .garan-label__preview ::v-deep svg,
    .garan-label__full ::v-deep svg {
      width: 100%;
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
